var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "locationSelectBox" }, [
    _c("span", [_vm._v("经营区域选择:")]),
    _vm._v(" "),
    _c(
      "div",
      _vm._l(_vm.cityOptions, function(item) {
        return _c(
          "el-button",
          {
            key: item.label,
            attrs: {
              type:
                item.label == _vm.city_location.label ? "primary" : "default"
            },
            on: {
              click: function($event) {
                return _vm.change_localtion(item)
              }
            }
          },
          [_vm._v(_vm._s(item.label))]
        )
      }),
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-5264918f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-5264918f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/base_b2c/changeLocation.vue
// module id = null
// module chunks = 